import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: 0;\n\tpointer-events: none;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: 100%;\n\tleft: 0;\n\tposition: absolute;\n\ttop: 0;\n\twidth: 100%;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmax-width: 100%;\n\tposition: relative;\n\twidth: 100%;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled } from '@wp-g2/styles';
export var AspectRatioView = styled.div(_templateObject());
export var content = css(_templateObject2());
export var AspectRatioResizer = styled.div(_templateObject3());